import { RemindersCOA } from './RemindersCOA';

export default RemindersCOA;
